import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { GameCategoryItem } from '@/models/dictionary/game-category.model';

export default class GetGameCategoryListRequest extends ApiResourceMethod<GameCategoryItem[]> {
  public perform(): Promise<GameCategoryItem[]> {
    return this.performer.requestWithMapper(
      {},
      (payload: BaseResponse<GameCategoryItem[]>) => {
        return payload.data;
      },
    );
  }
}
